import React from 'react';
import { Typography, Paper, makeStyles, Theme, IconButton } from '@material-ui/core';
import ReplayIcon from '@mui/icons-material/Replay';

import { useTemplateParser } from '../hooks/ImpactAiContextProvider';

interface UserMessageProps {
  text: string;
  className?: string;
  customStyle?: React.CSSProperties;
  canGoBack?: boolean;
  onGoBack?: (actionIndex?: number) => void;
  actionIndex?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  messageText: {
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    padding: theme.spacing(1),
  },
  messagePaper: {
    display: 'inline-block',
    width: 'auto',
    maxWidth: '80%',
  },
  backButton: {
    position: 'absolute',
    top: '-10px',
    right: '-5px',
    padding: theme.spacing(0.5),
    backgroundColor: '#F6F4FB',
    boxShadow: theme.shadows[1],
    opacity: 0.7,
    transition: 'opacity 0.2s',
    zIndex: 1,
    '&:hover': {
      backgroundColor: '#E8E8F0',
      opacity: 1,
    },
  },
  backButtonIcon: {
    fontSize: theme.typography.pxToRem(16),
  },
}));

const UserMessage: React.FC<UserMessageProps> = ({
  text,
  className = '',
  customStyle,
  canGoBack = false,
  onGoBack,
  actionIndex,
}) => {
  const classes = useStyles();
  const parseTemplate = useTemplateParser();

  // Parse the text to replace any template variables
  const parsedText = parseTemplate(text);

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack(actionIndex);
    }
  };

  return (
    <div className={classes.container}>
      <Paper className={`${classes.messagePaper} ${className}`} style={customStyle}>
        <Typography className={classes.messageText}>{parsedText}</Typography>
      </Paper>
      {canGoBack && onGoBack && (
        <IconButton
          className={classes.backButton}
          size="small"
          onClick={handleGoBack}
          aria-label="Go back to this choice"
        >
          <ReplayIcon className={classes.backButtonIcon} />
        </IconButton>
      )}
    </div>
  );
};

export default UserMessage;
